import styled from 'styled-components';
import { useEffect } from 'react';
import {
  IconButton, Flex, P,
  isUserWithRoles,
  UserRoles,
  useCombinedUser,
  useStyledTheme,
  useAsyncFunctionProgress,
} from '@equifinance/shared';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ApplicationsTable from '../components/ApplicationsTable/ApplicationsTable';
import Page from '../components/Page';
import { useApplicationsUIContext } from '../contexts/applications/ApplicationsUIProvider';
import BuidingIcon from '../components/Icons/BuildingIcon';

export const SubHeadContainer = styled(Flex)`${({ theme }) => `
  justify-content: space-between;
  gap: ${theme.padding[2]};
  align-items: center;
  height: ${theme.collapseHeaderHeight};
  padding: 0 ${theme.padding[8]};
  background: ${theme.colours.neutral[9]};
  box-shadow: ${theme.boxShadow[2]};
`}`;

export const RefreshContainer = styled(Flex)`${({ theme }) => `
  align-items: center;
  gap: ${theme.padding[4]};
  margin-left: auto;
`}`;

export const RefreshInfo = styled(P)`${({ theme }) => `
  color: ${theme.colours.neutral[3]};
`}`;

export const RefreshBtn = styled(IconButton)`${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bolder};
`}`;

const MyLink = styled(Link)`${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
  text-decoration: underline;
`}`;

export default function HomeUnderwriter() {
  const { refreshData, lastRetrieved, setLastRetrieved } = useApplicationsUIContext();
  const { user } = useCombinedUser();
  const canAccessBrokerMgmPage = isUserWithRoles(
    [UserRoles.UNDERWRITER, UserRoles.SALES_SUPPORT, UserRoles.BDM, UserRoles.READ_ONLY],
    user,
  );
  const theme = useStyledTheme();

  const handleRefresh = async () => {
    await refreshData();
  };

  const { inProgress, execute: executeRefresh } = useAsyncFunctionProgress(handleRefresh);

  useEffect(() => {
    setLastRetrieved(new Date());
  }, []);

  return (
    <Page subHeader={(
      <SubHeadContainer>
        {canAccessBrokerMgmPage && (
          <>
            <BuidingIcon fill={theme.colours.link[1]} />
            {
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <MyLink to="/broker-management">Manage Brokers</MyLink>
            }
          </>
        )}
        <RefreshContainer>
          <RefreshInfo>
            {`Last retrieved: ${moment(lastRetrieved).format('DD/MM/YYYY, HH:mm')}`}
          </RefreshInfo>
          <RefreshBtn disabled={inProgress} onClick={executeRefresh}>
            <i className="mi-refresh" />
            Refresh
          </RefreshBtn>
        </RefreshContainer>
      </SubHeadContainer>
    )}
    >
      <ApplicationsTable />
    </Page>
  );
}
